import { Link } from 'react-router-dom';
import { useTheme } from '../theme/ThemeContext';

const LOGO_DARK_ON_LIGHT = '/logo-black.png';
const LOGO_LIGHT_ON_DARK = '/logo-white.png';

// Ponthieu Pose et Rénovation — official logo. Auto-switches black/white based
// on the active theme so it always maximises contrast.
export default function Logo({ size = 88, className = '', forceWhite = false, ...rest }) {
  const { theme } = useTheme();
  const src = forceWhite ? LOGO_LIGHT_ON_DARK : (theme === 'dark' ? LOGO_LIGHT_ON_DARK : LOGO_DARK_ON_LIGHT);

  return (
    <Link
      to="/"
      aria-label="Ponthieu Pose et Rénovation — Accueil"
      className={`inline-flex items-center shrink-0 ${className}`}
      {...rest}
    >
      <img
        src={src}
        alt="Ponthieu Pose et Rénovation"
        className="block select-none pointer-events-none w-auto"
        draggable={false}
        style={{ height: `${size}px`, transition: 'opacity 400ms ease' }}
      />
    </Link>
  );
}
